import * as React from "react";
import { useParams } from "react-router-dom";
import { Box, Tab, Tabs } from "@mui/material";
import ReceivablesTab from "./tabs/ReceivablesTab";
import InvoicesTab from "./tabs/InvoicesTab";
import PayablesTab from "./tabs/PayablesTab";
import ManhoursTab from "./tabs/ManhoursTab";
import ProfitLossTab from "./tabs/ProfitLossTab";
import { MISProvider } from "./MISContext";
import DeviationTable from "./tabs/DeviationTableTab";
import PageHeader from "../../../../../components/PageHeader";
import { moduleTabProps } from "../../../../../components/ModuleIconBadge";
import { secondAxios } from "../../../../../api/axios";

function TabPanel({ value, index, children }) {
  if (value !== index) return null;
  return <Box sx={{ pt: 2 }}>{children}</Box>;
}

export default function MISTab() {
  const { plantId } = useParams();
  const [value, setValue] = React.useState(0);
  const [plant, setPlant] = React.useState({});

  const tabs = [
    { label: "Progress", moduleKey: "mis-progress", panel: <ReceivablesTab /> },
    { label: "Invoices", moduleKey: "mis-invoices", panel: <InvoicesTab /> },
    { label: "A/C Payables", moduleKey: "mis-payables", panel: <PayablesTab /> },
    {
      label: "Manhours Loading",
      moduleKey: "mis-manhours",
      panel: <ManhoursTab />,
    },
    {
      label: "Profit & Loss",
      moduleKey: "mis-profit-loss",
      panel: <ProfitLossTab />,
    },
    {
      label: "Deviation",
      moduleKey: "mis-deviation",
      panel: <DeviationTable />,
    },
  ];

  const handleChange = (_, newValue) => {
    setValue(newValue);
  };

  const getPlant = async () => {
    const res = await secondAxios.get(`/plant/${plantId}`);
    setPlant(res?.data || {});
  };

  React.useEffect(() => {
    getPlant();
  }, []);

  return (
    <MISProvider>
      <PageHeader
        plant={{ id: plantId, ...plant }}
        pageTitle="Management Information System (MIS)"
        moduleKey="mis"
      />

      <Box sx={{ width: "100%", p: 2, pt: 0, position: "relative" }}>
        <Tabs value={value} onChange={handleChange} sx={{ mt: 2 }}>
          {tabs.map((tab) => (
            <Tab
              key={tab.label}
              label={tab.label}
              {...moduleTabProps(tab.moduleKey)}
            />
          ))}
        </Tabs>
        {tabs.map((tab, index) => (
          <TabPanel key={tab.label} value={value} index={index}>
            {tab.panel}
          </TabPanel>
        ))}
      </Box>
    </MISProvider>
  );
}
